function initMarquee(element, speed, forward) {
  if (forward) {
    element.classList.add('forward');
  }
  // wrap all elements in a div
  const marquee = document.createElement('div');
  marquee.classList.add('marquee');
  Array.from(element.children).forEach((child) => {
    marquee.appendChild(child);
  });
  element.appendChild(marquee);

  // copy a few times
  const clone = marquee.cloneNode(true);
  const clone2 = marquee.cloneNode(true);

  marquee.insertAdjacentElement('afterend', clone);
  marquee.insertAdjacentElement('afterend', clone2);

  // start animation
  let i = 0;

  const animate = () => {
    element.style.setProperty('--x', `${forward ? '' : '-'}${i}px`);
    if (i > marquee.clientWidth) {
      i = 0;
    }
    i = i + speed;
    requestAnimationFrame(animate);
  };

  animate();
}

export function logoMarquee() {
  // find all .is-style-logo-carousel
  const logoCarousels = document.querySelectorAll('.is-style-logo-carousel');

  // if there are no .is-style-logo-carousel, return
  if (!logoCarousels.length) {
    return;
  }

  logoCarousels.forEach((logoCarousel, i) => {
    // const speed = i % 2 === 0 ? 0.5 : -0.5;
    initMarquee(logoCarousel, 0.5, i % 2 === 0);
  });
}
